/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_From_CodebaseInputs */

const en_mk_foot_from_codebase = /** @type {(inputs: Mk_Foot_From_CodebaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From a codebase`)
};

const id_mk_foot_from_codebase = /** @type {(inputs: Mk_Foot_From_CodebaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari codebase`)
};

/**
* | output |
* | --- |
* | "From a codebase" |
*
* @param {Mk_Foot_From_CodebaseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_from_codebase = /** @type {((inputs?: Mk_Foot_From_CodebaseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_From_CodebaseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_from_codebase(inputs)
	return en_mk_foot_from_codebase(inputs)
});